function highlight(searchTerm, content, caseSensitive) {
  if (caseSensitive === void 0) {
    caseSensitive = false;
  }
  var _final = '';
  var spanStart = '<span class="text-highlight">';
  var spanEnd = '</span>';
  if (searchTerm !== undefined && searchTerm != null && searchTerm.length > 0 && searchTerm[0] !== '.') {
    var separatedText = [];
    var separatedSearchedText = [];
    var contentMatch = caseSensitive ? content : content.toLocaleLowerCase();
    var searchTermMatch = caseSensitive ? searchTerm : searchTerm.toLocaleLowerCase();
    var separatedTextArr = contentMatch.split(searchTermMatch);
    var searchLength = searchTermMatch.length;
    var leftIndex = 0;
    for (var i = 0, arrLength = separatedTextArr.length; i < arrLength; i++) {
      var oneTextLength = separatedTextArr[i].length;
      separatedText.push(content.substring(leftIndex, leftIndex + oneTextLength));
      leftIndex += oneTextLength;
      if (i < arrLength - 1) {
        separatedSearchedText.push(content.substring(leftIndex, leftIndex + searchLength));
        leftIndex += searchLength;
      }
    }
    if (separatedSearchedText != null && separatedSearchedText.length > 0) {
      for (var _i = 0; _i < separatedText.length; _i++) {
        if (_i <= separatedSearchedText.length - 1) {
          _final += separatedText[_i] + spanStart + separatedSearchedText[_i] + spanEnd;
        } else {
          _final += separatedText[_i];
        }
      }
    }
    if (_final.length > 0) {
      return "<span>" + _final + "<span>";
    } else {
      return content;
    }
  } else {
    return content;
  }
}
function highlightTime(content, searchTerm) {
  var splitFlag = 'i',
    matchFlag = 'gi';
  if (searchTerm && searchTerm.length > 0 && searchTerm[0] !== '.') {
    var _final2 = '';
    var spanStart = '<span class="text-highlight">',
      spanEnd = '</span>';
    var searchPattern = new RegExp(searchTerm, splitFlag),
      matchpattern = new RegExp(searchTerm, matchFlag);
    var separatedText = content.split(searchPattern);
    var separatedSearchedText = content.match(matchpattern);
    if (separatedSearchedText && separatedSearchedText.length > 0) {
      for (var i = 0; i < separatedText.length; i++) {
        if (i <= separatedSearchedText.length - 1) {
          _final2 += separatedText[i] + spanStart + separatedSearchedText[i] + spanEnd;
        } else {
          _final2 += separatedText[i];
        }
      }
    }
    if (_final2.length > 0) {
      return "<span>" + _final2 + "<span>";
    } else {
      return content ? content : '';
    }
  } else {
    return content ? content : '';
  }
}
export { highlight, highlightTime };